import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=1c25355a&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c25355a', component.options)
    } else {
      api.reload('1c25355a', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=1c25355a&", function () {
      api.rerender('1c25355a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Notifications.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Notifications.vue
// module id = WodM
// module chunks = 0